import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind classes, letting later classes win over earlier conflicts. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Keyboard focus for every interactive control: the design system's pale lime
 * halo, plus a darker edge inside it, because the halo alone is too faint to
 * see against a white surface.
 */
export const focusRing =
  'outline-none focus-visible:outline-1 focus-visible:outline-offset-0 focus-visible:outline-ring-strong focus-visible:ring-[3px] focus-visible:ring-ring';
